module.exports = __webpack_public_path__ + "img/edit-date-time-icon.15fe8e2b.svg";